import { Injectable } from '@angular/core';
import { BinaryWriter } from 'google-protobuf';
import { Benefit } from '../../../libs/proto/commUnity_pb';

@Injectable({
  providedIn: 'root'
})
export class BenefitConversionService {
  constructor() { }

  ToStorage(req: Benefit ){
    const w = new BinaryWriter();
    Benefit.serializeBinaryToWriter(req, w);

    const abuf = w.getResultBuffer();
    return Array.from // if available
              ? Array.from(abuf) // use Array#from
              : abuf.map(v => v);
  }

  FromStorage(data: any, callback: (benefit: Benefit, errorConvert: any) => void) {
    try {
      callback( Benefit.deserializeBinary(data), null);
    } catch (error) {
      callback( null, error);
    }
  }

  ToStorages(benefit: Benefit[]) {
    const rets = new Array<Uint8Array | number[]>();

    benefit.forEach(element => {
      rets.push(
        this.ToStorage(element)
      );
    });

    return {data: rets};
  }

  FromStorages(data: any, callback: (news: Benefit[], errorConvert: any) => void) {
    if (data == null) {
      callback(null, Error('empty'));
      return;
    }
    const emps = new Array<Benefit>();
    const empjs: {data: (Uint8Array)[]} = data;
    try {

      empjs.data.forEach(element => {
        const emp = Benefit.deserializeBinary( element  );
        emps.push ( emp );
      });

      callback( emps, null);
    } catch (error) {
      callback( null, error);
    }
  }

}
